import { render, staticRenderFns } from "./GhostWriterTemplateApp.vue?vue&type=template&id=07d5aea4&scoped=true"
import script from "./GhostWriterTemplateApp.vue?vue&type=script&lang=js"
export * from "./GhostWriterTemplateApp.vue?vue&type=script&lang=js"
import style0 from "./GhostWriterTemplateApp.vue?vue&type=style&index=0&id=07d5aea4&prod&lang=scss"
import style1 from "./GhostWriterTemplateApp.vue?vue&type=style&index=1&id=07d5aea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5aea4",
  null
  
)

export default component.exports